import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { LanguageContext } from '../LanguageContext';

function About() {
  const A_propos = require('../img/img3.jpg');
  const { language } = useContext(LanguageContext);

  const content = {
    fr: {
      title: 'Votre Voyage Spirituel, Notre Engagement',
      description1:
        'Chez <span className="font-semibold text-green-600">Doyouf Arahman Travels</span>, nous sommes passionnés par la facilitation de voyages Omra et Hajj qui transcendent le simple déplacement. Nous comprenons que ces pèlerinages sont des moments spirituels profonds, des quêtes de sérénité et de proximité avec le divin.',
      description2:
        'Forts d\'une expertise approfondie et d\'une connaissance intime des lieux saints, notre équipe dévouée s\'engage à vous offrir une expérience inoubliable, alliant confort, sérénité et spiritualité. Nous prenons en charge chaque détail logistique avec soin, pour que vous puissiez vous concentrer pleinement sur votre démarche spirituelle.',
      description3:
        'Notre objectif est de vous accompagner à chaque étape, en vous offrant un service personnalisé et attentif, pour que votre Omra ou votre Hajj soit un voyage transformateur et enrichissant à tous points de vue.',
    },
    ar: {
      title: 'رحلتك الروحية، التزامنا',
      description1:
        'في <span className="font-semibold text-green-600">أسفار ضيوف الرحمن </span>، نحن متحمسون لتسهيل رحلات العمرة والحج التي تتجاوز مجرد التنقل. نحن نتفهم أن هذه الرحلات هي لحظات روحية عميقة، بحث عن السكينة والقرب من الله.',
      description2:
        'بفضل خبرتنا الواسعة ومعرفتنا العميقة بالأماكن المقدسة، يلتزم فريقنا المتفاني بتقديم تجربة لا تُنسى، تجمع بين الراحة والسكينة والروحانية. نحن نتعامل مع كل التفاصيل اللوجستية بعناية، حتى تتمكن من التركيز بالكامل على مسارك الروحي.',
      description3:
        'هدفنا هو مرافقتك في كل خطوة، من خلال تقديم خدمة شخصية ومراعية، حتى تكون عمرتك أو حجك رحلة تحويلية وغنية بكل النواحي.',
    },
  };

  const imageAnimation = {
    hidden: { opacity: 0, scale: 0.9, rotate: -5 },
    visible: { opacity: 1, scale: 1, rotate: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  const textAnimation = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  return (
    <section className="py-20 bg-gradient-to-r from-blue-50 via-green-100 to-blue-50">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={textAnimation}
            className="h-full flex flex-col justify-center"
          >
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-6 hover:text-green-600 transition-colors duration-300">
              {content[language].title}
            </h2>
            <p
              className="text-gray-700 leading-relaxed mb-6"
              dangerouslySetInnerHTML={{ __html: content[language].description1 }}
            ></p>
            <p
              className="text-gray-700 leading-relaxed mb-6"
              dangerouslySetInnerHTML={{ __html: content[language].description2 }}
            ></p>
            <p
              className="text-gray-700 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: content[language].description3 }}
            ></p>
          </motion.div>

         
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={imageAnimation}
            className="h-full flex items-center"
          >
            <img
              src={A_propos}
              alt="À propos de Doyouf Arahman Travels - Voyage/ Omra et Hajj"
              className="w-full max-h-[500px] object-cover rounded-lg shadow-2xl hover:shadow-3xl transition-shadow duration-300 transform hover:scale-105"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default About;